module.exports = __webpack_public_path__ + "static/media/tipsImg3.bcc88f7f.png";